module.exports = __webpack_public_path__ + "teqbahn-assets/media/bg.448a8afb.png";